import { render, staticRenderFns } from "./Packer.vue?vue&type=template&id=b43c2762&"
import script from "./Packer.vue?vue&type=script&lang=js&"
export * from "./Packer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b43c2762')) {
      api.createRecord('b43c2762', component.options)
    } else {
      api.reload('b43c2762', component.options)
    }
    module.hot.accept("./Packer.vue?vue&type=template&id=b43c2762&", function () {
      api.rerender('b43c2762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Packer.vue"
export default component.exports